import {fade} from '@material-ui/core/styles/colorManipulator';

const hexToRgba = (hex: string, alpha = 1) => fade(hex, alpha);

export {hexToRgba};
